import { lazy } from "react";

export const PublicOrganizationPageAsync = lazy(async function () {
  return import("./PublicOrganizationPage").then((m) => ({ default: m.PublicOrganizationPage }));
});
